<template>
  <div class="cell-container">
    <h1>【错误如图所示】</h1>

    <div class="image"><img src="@/assets/ksxg/banner01.png" /></div>
    <div class="text">
      <span>
        针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。</span
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.cell-container {
  transition: all 0.6s;
  &:hover {
    box-shadow: 3px 3px 3px #eeeeee;
    transform: scale(1.01, 1.01);
    transition: all 0.6s;
  }
  border: solid 1px #dedfe1;
  width: 1200px;
  margin: 20px auto;
  text-align: left;
  padding:40px;
  .image {
    margin-top:20px;
    width: 300px;
    height: 127px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .text {
    width: 900px;
    padding: 20px 0;

    .date {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
